import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=3028d101"
import script from "./EventItem.vue?vue&type=script&lang=ts"
export * from "./EventItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports